import API from "../../api";
import { isSandbox } from "../../../config";

const liveBuyIn = (user) => {
    return new API(user).postRequest('/liveBuyIn', {sandbox: isSandbox ? 1 : 0});
}

export default liveBuyIn;